import { enforceMaxLength, togglePhotoTextZoneButtons, togglePhotoTextZoneResetButton } from '../../../utils';

type FillPhotoZoneWithOverlayTextProps = {
  canvas: fabric.Canvas;
  textBox: fabric.Textbox;
  photoTextZone: fabric.Group;
  text: string;
  SAS_DYNAMIC_BUTTONS: boolean;
};

export const fillPhotoZoneWithOverlayText = ({
  canvas,
  text,
  textBox,
  photoTextZone,
  SAS_DYNAMIC_BUTTONS,
}: FillPhotoZoneWithOverlayTextProps) => {
  const groupHeight = photoTextZone.height || 0;
  const groupWidth = photoTextZone.width || 0;

  if (text !== '') {
    textBox.set({
      textAlign: textBox.textAlign,
      fontSize: textBox.fontSize,
      fontFamily: textBox.fontFamily,
      text: enforceMaxLength(text, 3000),
      visible: true,
      originX: 'center',
      originY: 'top', // Changed from 'center' to 'top'
      left: 0,
      top: -(photoTextZone.height || 0) / 2, // Offset to align to top of group
      height: groupHeight,
      width: groupWidth,
      lockScalingX: true,
      lockScalingY: true,
      borderDashArray: [0, 0],
    });

    textBox.data.hasContent = true;
    textBox.setCoords(); // Update textbox coords only

    // Don't use addWithUpdate() - it recalculates group layout
    // Just mark the group as dirty and update its coords
    photoTextZone.dirty = true;
    photoTextZone.setCoords();

    togglePhotoTextZoneButtons(false, canvas, photoTextZone, SAS_DYNAMIC_BUTTONS);
    togglePhotoTextZoneResetButton(true, canvas, photoTextZone);
  }
  canvas.renderAll();
};
